export { default } from './ExternalLogout';
